var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { AppContext } from "./appContext";
import ChatBubble from "./components/ChatBubble";
import { CHAT_PREFS, CHAT_PREFS_FETCH_URL_PATH, CONVERSATIONS_FETCH_URL_PATH, VISITOR_ID, DOMAIN_ID, PARENT_WINDOW, GET_BIG_TEXT_URL_PATH, WINDOW_OPEN, OPENED_CHAT, OPERATORS, WIDGET_ACTIVE_TAB, PROACTIVE_MESSAGE, CHAT_PREFS_VALIDATE_CAN_SHOW_WIDGET, OPENED_FLOW, } from "./globals";
import { getReq } from "./request";
import Pusher from "pusher-js";
import { getSessionStoragePrefs, removeSessionStoragePrefs, setSessionStoragePrefs, } from "./Storage";
import Home from "./Home";
import LiveChat from "./LiveChat";
import { pushMessage, resizeFrame } from "./Utils";
import HelpCenter from "./HelpCenter";
import Tickets from "./Tickets";
import Loader from "./components/Loader";
import NewPromptMessage from "./NewPromptMessage";
export var widgetFooterTabs;
(function (widgetFooterTabs) {
    widgetFooterTabs["Home"] = "Home";
    widgetFooterTabs["Messages"] = "Messages";
    widgetFooterTabs["Loader"] = "Loader";
    widgetFooterTabs["Tickets"] = "Tickets";
    widgetFooterTabs["Help"] = "Help";
})(widgetFooterTabs || (widgetFooterTabs = {}));
export var PromtWidth;
(function (PromtWidth) {
    PromtWidth["Small"] = "Small";
    PromtWidth["Large"] = "Large";
})(PromtWidth || (PromtWidth = {}));
export var NotificationPromtTypes;
(function (NotificationPromtTypes) {
    NotificationPromtTypes["Livechat"] = "Livechat";
    NotificationPromtTypes["Ticket"] = "Ticket";
    NotificationPromtTypes["Proactive"] = "Proactive";
})(NotificationPromtTypes || (NotificationPromtTypes = {}));
var App = function () {
    var _a = useState(true), enabledChatWidget = _a[0], setEnabledChatWidget = _a[1];
    // Context states
    var _b = useState(CHAT_PREFS || []), chatPrefs = _b[0], setChatPrefs = _b[1];
    var _c = useState(CHAT_PREFS ? (!(CHAT_PREFS.businessHours && CHAT_PREFS.businessHours.showOnlyOnBusinessHours)) : true), isVisible = _c[0], setIsVisible = _c[1];
    useEffect(function () {
        if (chatPrefs && chatPrefs.id)
            canShowChatWidget(chatPrefs);
    }, [chatPrefs]);
    var _d = useState(getSessionStoragePrefs(OPERATORS)
        ? JSON.parse(getSessionStoragePrefs(OPERATORS))
        : []), agents = _d[0], setAgents = _d[1];
    var _e = useState([]), sessions = _e[0], setSessions = _e[1];
    var getWidgetActiveTabs = function () {
        var _a, _b, _c;
        if ((chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.widget) && !((_a = chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.widget) === null || _a === void 0 ? void 0 : _a.chat_footer_settings) || ((_b = chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.widget) === null || _b === void 0 ? void 0 : _b.chat_footer_settings.length) == 0) {
            chatPrefs.widget.chat_footer_settings = [
                {
                    tab: widgetFooterTabs.Home,
                    enable: true,
                },
                {
                    tab: widgetFooterTabs.Messages,
                    enable: true
                },
                {
                    tab: widgetFooterTabs.Tickets,
                    enable: false
                },
                {
                    tab: widgetFooterTabs.Help,
                    enable: false
                },
            ];
        }
        var footerTabs = (_c = chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.widget) === null || _c === void 0 ? void 0 : _c.chat_footer_settings.filter(function (footer) { return footer.enable == true; });
        var activeTabname = getSessionStoragePrefs(WIDGET_ACTIVE_TAB);
        if (!activeTabname)
            activeTabname = widgetFooterTabs.Home;
        try {
            if (!footerTabs.find(function (footer) { return footer.tab == activeTabname; })) {
                activeTabname = footerTabs[0].tab;
            }
        }
        catch (error) { }
        return activeTabname;
    };
    var _f = useState(getWidgetActiveTabs()), activeTab = _f[0], setActiveTab = _f[1];
    var _g = useState(PromtWidth.Small), promtWidth = _g[0], setPromtWidth = _g[1];
    // Maintaining the recent session when message inbound or outboud times are updated.
    // const [hideChatBubble, setHideChatBubble] = useState<boolean>(false);
    var _h = useState(getSessionStoragePrefs(WINDOW_OPEN) ? true : false), isOpened = _h[0], setIsOpened = _h[1];
    var _j = useState({
        enabled: false,
        type: undefined,
        info: undefined,
        id: undefined,
    }), notificationPrompt = _j[0], setNotificationPrompt = _j[1];
    var _k = useState(undefined), pusherChannel = _k[0], setPusherChannel = _k[1];
    // const [activeSessionDetails, setActiveSessionDetails] = useState<ActiveSessionObjType>({
    //   session_id: undefined,
    //   session_type: undefined,
    //   session: undefined
    // });
    var _l = useState(CHAT_PREFS ? true : false), prefsFetched = _l[0], setPrefsFetched = _l[1];
    var _m = useState(true), loadingSessions = _m[0], setLoadingSessions = _m[1];
    useEffect(function () {
        setActiveTab(getWidgetActiveTabs());
    }, [chatPrefs]);
    useEffect(function () {
        setPromtWidth(PromtWidth.Small);
        setSessionStoragePrefs(WIDGET_ACTIVE_TAB, activeTab);
    }, [activeTab]);
    useEffect(function () {
        if (isOpened)
            setIsVisible(true);
        setTimeout(function () {
            if (!isOpened && !notificationPrompt.enabled) {
                resizeFrame((!isVisible) ? "LIVECHAT_WRAPPER_CLOSED" : "WINDOW_CLOSED");
            }
            else {
                resizeFrame(promtWidth && promtWidth == PromtWidth.Large
                    ? "WINDOW_OPENED_LARGE"
                    : "WINDOW_OPENED");
            }
        }, 300);
    }, [promtWidth, isOpened, isVisible]);
    useEffect(function () {
        console.log("useEffect1");
        // Fetch chat prefs
        fetchChatPrefs();
        // Restore storage prefs
        // console.log("this.$isNewSession", this.$isNewSession);
        // if (IS_NEW_SESSION) {
        //   removeSessionStoragePrefs("window-open");
        //   removeSessionStoragePrefs("opened-chat");
        //   // deleteStoragePrefs("opened-chat-type");
        // }
        executeWebrules();
        // Fetch conversations
        fetchConversationsAndAgents();
        // Open window on localstorage value
        // let opened = getStoragePrefs("window-open");
        // if (opened && opened === "true") {
        //   // Open window
        //   chatBubbleClicked();
        // }
    }, []);
    useEffect(function () {
        bindPusherSocketEvents();
    }, [pusherChannel, sessions]);
    var closeNotify = function (e) {
        e.stopPropagation();
        setNotificationPrompt({
            enabled: false,
            type: undefined,
            info: undefined,
            id: undefined,
        });
        resizeFrame((!isVisible) ? "LIVECHAT_WRAPPER_CLOSED" : "WINDOW_CLOSED");
    };
    var openNotify = function () {
        var _a;
        var activeTab = widgetFooterTabs.Messages;
        setActiveTab(activeTab);
        chatBubbleClicked();
        if (notificationPrompt.type == NotificationPromtTypes.Proactive) {
            startNewChat((_a = notificationPrompt.info) === null || _a === void 0 ? void 0 : _a.message);
        }
        else if (notificationPrompt.id &&
            notificationPrompt.type == NotificationPromtTypes.Livechat)
            openChat(notificationPrompt.id);
    };
    var fetchChatPrefs = function () {
        if (!CHAT_PREFS) {
            var wait = getReq(CHAT_PREFS_FETCH_URL_PATH, {});
            wait
                .then(function (response) {
                // validate busines hours
                var prefs = response.data;
                if (prefs.botPrefs && prefs.botPrefs.length > 0)
                    prefs.matchedBotPrefs = prefs.botPrefs[0];
                if (prefs.flowPrefs && prefs.flowPrefs.length > 0)
                    prefs.matchedFlowPrefs = prefs.flowPrefs[0];
                setChatPrefs(prefs);
                setPrefsFetched(true);
            })
                .catch(function () { });
        }
        else {
            setPrefsFetched(true);
        }
    };
    var canShowChatWidget = function (prefs) {
        if (!prefs || !prefs.businessHours || !prefs.businessHours.showOnlyOnBusinessHours)
            return;
        // if (!prefs.businessHours.considerUsersBusinessHours) {
        //   const bHour = isBusinessHourNow(prefs.businessHours);
        //   if (!bHour)
        //     setIsVisible(true);
        //   return;
        // }
        var wait = getReq(CHAT_PREFS_VALIDATE_CAN_SHOW_WIDGET, {});
        wait
            .then(function (response) {
            // validate busines hours
            if (response && response.data && response.data.show_widget)
                setIsVisible(true);
        })
            .catch(function () { });
    };
    var chatBubbleClicked = function () {
        notificationPrompt.enabled &&
            setNotificationPrompt({
                enabled: false,
                type: undefined,
                info: undefined,
                id: undefined,
            });
        if (!isOpened) {
            resizeFrame(promtWidth && promtWidth == PromtWidth.Large
                ? "WINDOW_OPENED_LARGE"
                : "WINDOW_OPENED");
        }
        else {
            setIsOpened(!isOpened);
            setTimeout(function () {
                // resizeFrame((!isVisible) ? "LIVECHAT_WRAPPER_CLOSED" : "WINDOW_CLOSED");
            }, 2000);
        }
        setTimeout(function () {
            setIsOpened(!isOpened);
            // Setting
            // setPromtWidth(PromtWidth.Small);
            setSessionStoragePrefs(WINDOW_OPEN, !isOpened);
            if (isOpened) {
                removeSessionStoragePrefs(WINDOW_OPEN);
                // removeSessionStoragePrefs(OPENED_CHAT);
                // deleteStoragePrefs("opened-chat-type");
            }
        }, 50);
    };
    var fetchConversationsAndAgents = function () {
        var await2 = getReq(CONVERSATIONS_FETCH_URL_PATH, {});
        await2
            .then(function (response) {
            console.log(response);
            var agentsList = agents;
            response.data.operators.forEach(function (agent) {
                agentsList.push(agent);
            });
            setSessionStoragePrefs(OPERATORS, JSON.stringify(response.data.operators));
            setAgents(response.data.operators);
            var sessionsList = sessions;
            response.data.sessions.forEach(function (session) {
                sessionsList.push(session);
            });
            setSessions(__spreadArray([], sessionsList, true));
            setLoadingSessions(false);
            if (sessions.length > 0)
                createSocket();
            // Check for opened chat
            var openedChat = getSessionStoragePrefs(OPENED_CHAT);
            if (openedChat) {
                openChat(openedChat);
            }
        })
            .catch(function (e) {
            console.log(e);
        });
    };
    var isPromptEnabled = function () {
        return notificationPrompt.enabled;
    };
    var executeWebrules = function () {
        if (PARENT_WINDOW &&
            PARENT_WINDOW.EhWebRules &&
            !PARENT_WINDOW.EhWebRules.webRulesFetched) {
            setTimeout(function () {
                executeWebrules();
            }, 500);
        }
        if (!PARENT_WINDOW || !PARENT_WINDOW.EhWebRules)
            return;
        PARENT_WINDOW.EhWebRules.executeScopeBasedRules("LIVECHAT", function (rule) {
            // console.log("rule1", rule);
            var ruleType = rule.actionType;
            if (!ruleType)
                return;
            // console.log("ruleType", ruleType);
            switch (ruleType) {
                case "LIVECHAT_PROACTIVE_MESSAGE":
                    setTimeout(function () {
                        // Show proactive message
                        var proactiveMsg = "";
                        try {
                            proactiveMsg = JSON.parse(rule.customData).message;
                        }
                        catch (error) { }
                        // console.log("proactiveMsg", proactiveMsg);
                        // if (proactiveMsg)
                        // setIsOpened(true);
                        var opened = getSessionStoragePrefs(WINDOW_OPEN);
                        if (!opened && !isPromptEnabled() && proactiveMsg) {
                            // setLoadingChats(false);
                            // chatBubbleClicked();
                            resizeFrame("WINDOW_OPENED");
                            setNotificationPrompt({
                                enabled: true,
                                type: NotificationPromtTypes.Proactive,
                                info: { message: proactiveMsg, user_id: undefined },
                                id: undefined,
                            });
                            // startNewChat(proactiveMsg);
                            // setSessionStoragePrefs(
                            //   "notification_type",
                            //   NotificationPromtTypes.Proactive
                            // );
                        }
                        // showProactiveMessage(proactiveMsg);
                    }, 1000);
                    break;
                case "LIVECHAT_HIDE":
                    setIsVisible(false);
                    break;
                default:
                    break;
            }
            // Saving visitor
            if (PARENT_WINDOW && rule && rule.id)
                PARENT_WINDOW.EhGrabberVisitor.saveFrequency(rule.id);
        });
    };
    var openChat = function (id) {
        setSessionStoragePrefs(OPENED_CHAT, id);
        changeActiveTab(widgetFooterTabs.Messages);
    };
    var startFlow = function (id) {
        setSessionStoragePrefs(OPENED_FLOW, id);
        changeActiveTab(widgetFooterTabs.Messages);
    };
    var startNewChat = function (initialMessage) {
        setSessionStoragePrefs(OPENED_CHAT, "new");
        if (initialMessage)
            setSessionStoragePrefs(PROACTIVE_MESSAGE, initialMessage);
        else
            removeSessionStoragePrefs(PROACTIVE_MESSAGE);
        changeActiveTab(widgetFooterTabs.Messages);
    };
    var changeActiveTab = function (tab) {
        if (activeTab == tab) {
            setActiveTab(widgetFooterTabs.Loader);
            setTimeout(function () {
                setActiveTab(tab);
            }, 10);
        }
        else {
            setActiveTab(tab);
        }
    };
    var getSessionById = function (id) {
        if (!id)
            return undefined;
        return sessions.find(function (session) {
            return session.id === Number(id);
        });
    };
    var bindPusherSocketEvents = function () {
        if (pusherChannel && pusherChannel.bind) {
            console.log("Binding channel");
            // unbind to event for messages
            pusherChannel.unbind("engagebay-event");
            // Subscribe to event for messages
            pusherChannel.bind("engagebay-event", function (message, channel, ortc) {
                try {
                    console.log("currentSessionId2  ", message);
                    processIncomingMessage(JSON.parse(message));
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    };
    var createSocket = function () {
        console.log("connectingsocket again");
        // Get user sessions from visitorId
        var channelName = DOMAIN_ID ? DOMAIN_ID + "-" + VISITOR_ID : VISITOR_ID;
        var pusher = new Pusher("1bd6d84d7a6d517eeee5", {
            cluster: "ap2",
            forceTLS: true,
        });
        var channel = pusher.subscribe(channelName);
        console.log("channelname", channelName);
        setPusherChannel(pusher);
    };
    var processIncomingMessage = function (event) {
        // Handle big text messages
        if (event.event_type == "BIG_TEXT") {
            getBigMessage(event.BIG_TEXT_ID, function (response) {
                handleMessage(JSON.parse(response.message));
            });
            return;
        }
        handleMessage(event);
    };
    var getBigMessage = function (messageId, callback) {
        var wait = getReq(GET_BIG_TEXT_URL_PATH + messageId, {});
        wait
            .then(function (response) {
            if (callback)
                callback(response.data);
        })
            .catch(function () { });
    };
    var handleMessage = function (event) {
        console.log("handleMessage", event);
        // If typing alert
        if (event.event_type == "TYPING") {
            console.log("TYPING", event.message);
            handleInboundTyping(event.message);
            return;
        }
        // If CALL alert
        //   if (event.event_type == "CALL_ALERT") {
        //     console.log("CALL_ALERT", event);
        //     this.handleCallRequest(event.message);
        //     return;
        //   }
        var chat_message = event.message
            .message;
        console.log(chat_message);
        if (!chat_message)
            return;
        console.log("pusgedd alreadd");
        sessions.forEach(function (element) {
            console.log("availablesessionids", element.id);
        });
        var session = getSessionById(chat_message.session_id);
        console.log("sessionunavailabnle", chat_message.session_id);
        if (!session)
            return;
        session.connected_with = event.message.session.connected_with;
        //If system message
        if (event.event_type === "SYSTEM_MESSAGE" ||
            chat_message.from === "System") {
            var message_type = chat_message.system_message_type;
            var systemMssgArray = [
                "CHAT_SESSION_ASSIGNED_TO_USER",
                "CHAT_SESSION_TRANSFERED_TO_ANOTHER_USER",
                "CHAT_SESSION_ADD_ANOTHER_USER_TO_CONFERENCE",
            ];
            if (message_type && systemMssgArray.includes(message_type)) {
                session.first_answered_by_user_id =
                    event.message.session.first_answered_by_user_id;
                session.participant_user_ids =
                    event.message.session.participant_user_ids;
            }
            if (!chat_message.message)
                return;
        }
        pushMessage(chat_message, session);
        setSessions(__spreadArray([], sessions, true));
        // Set prompt message
        if (!isOpened) {
            setNotificationPrompt({
                enabled: true,
                type: NotificationPromtTypes.Livechat,
                info: event.message.message,
                id: session.id + "",
            });
            setTimeout(function () {
                resizeFrame("WINDOW_OPENED");
            }, 100);
            if (!isVisible) {
                setIsVisible(true);
            }
        }
    };
    // Set prompt session
    //const setPromptedSession = (sessionId: number) => {
    // if (newMessageAlert) return;
    // setNewMessageAlert(true);
    // setAlertMessageSessionId(sessionId.toString());
    //};
    //const resetPromptedSession = () => {
    // setNewMessageAlert(false);
    // setAlertMessageSessionId("");
    //};
    var handleInboundTyping = function (message) {
        // Holding for a moment to make changes live
        // with PUSHER service
        // if (true) return;
        // Get session I from noty message
        if (!message.session_id)
            return;
        // Get session from ID
        var session = getSessionById(message.session_id);
        // console.log("handleInboundTyping", session);
        if (!session)
            return;
        // Set reactivity dynamic
        var time = new Date().getTime();
        session.typing = true;
        session.typing_alert = time;
        setSessions(__spreadArray([], sessions, true));
    };
    var addNewSession = function (session) {
        var availableIndex = sessions.findIndex(function (eahSession) {
            return eahSession.id == session.id;
        });
        if (availableIndex > -1) {
            sessions.splice(availableIndex, 1);
        }
        sessions.push(session);
        setSessions(__spreadArray([], sessions, true));
        console.log(sessions);
        if (!pusherChannel)
            createSocket();
    };
    var appThemeStyle = useMemo(function () {
        var _a, _b;
        var settings = (_a = chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.widget) === null || _a === void 0 ? void 0 : _a.chat_footer_settings.filter(function (footer) { return footer.enable == true; });
        var setting = (_b = chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.widget) === null || _b === void 0 ? void 0 : _b.chat_footer_settings.find(function (footer) { return footer.enable == true; });
        return {
            "--bottom": (settings === null || settings === void 0 ? void 0 : settings.length) < 2 ? "20px" : "125px",
            "--reduceHeight": (settings === null || settings === void 0 ? void 0 : settings.length) < 2 ? "135px" : "210px",
            "--themeColor": chatPrefs && chatPrefs.widget && chatPrefs.widget.colorCode
                ? chatPrefs.widget.colorCode
                : "blue",
            "--errorColor": "#ed3248",
            "--themeColor2": chatPrefs && chatPrefs.widget && chatPrefs.widget.colorCode2
                ? chatPrefs.widget.colorCode2
                : "red",
        };
    }, [chatPrefs]);
    if (prefsFetched) {
        return (_jsx(AppContext.Provider, __assign({ value: {
                agents: agents,
                setAgents: setAgents,
                chatPrefs: chatPrefs,
                chatBubbleClicked: chatBubbleClicked,
                setChatPrefs: setChatPrefs,
                sessions: sessions,
                setSessions: setSessions,
                activeTab: activeTab,
                changeActiveTab: changeActiveTab,
                promtWidth: promtWidth,
                setPromtWidth: setPromtWidth,
            } }, { children: _jsxs("div", __assign({ id: "App", className: "engagebay-viewport ".concat(!isOpened && !isVisible ? "hide" : "", " "), style: appThemeStyle }, { children: [_jsx("div", __assign({ className: "eb-chat-force-display-externally hide", onClick: function () {
                            setIsVisible(true);
                            chatBubbleClicked();
                        } }, { children: "Show Bubble" })), isVisible ? (_jsxs(_Fragment, { children: [_jsx(ChatBubble, { isVisible: isVisible, notifyEnabled: notificationPrompt.enabled, setIsVisible: setIsVisible, chatBubbleClicked: chatBubbleClicked, opened: isOpened }), notificationPrompt.enabled ? (_jsx(NewPromptMessage, { info: notificationPrompt.info, close: closeNotify, open: openNotify })) : (_jsx("div", __assign({ className: "chat ".concat(isOpened ? "is-open" : "", " \n              ").concat(chatPrefs.widget.position == "LEFT" ? "left" : "", " \n              ").concat(chatPrefs.widget.position == "RIGHT" ? "right" : ""), "data-target": "widget" }, { children: _jsx("div", __assign({ className: "chat__main", style: {
                                        minWidth: "".concat(promtWidth == PromtWidth.Large ? "700px" : "auto"),
                                    } }, { children: (function () {
                                        if (widgetFooterTabs.Home == activeTab) {
                                            return (_jsx(Home, { openChat: openChat, startFlow: startFlow, startNewChat: startNewChat }));
                                        }
                                        if (widgetFooterTabs.Messages == activeTab) {
                                            return (_jsx(LiveChat, { loadingSessions: loadingSessions, openChat: openChat, startNewChat: startNewChat, addNewSession: addNewSession, startFlow: startFlow }));
                                        }
                                        if (widgetFooterTabs.Loader == activeTab) {
                                            return _jsx(Loader, {});
                                        }
                                        if (widgetFooterTabs.Tickets == activeTab) {
                                            return _jsx(Tickets, {});
                                        }
                                        if (widgetFooterTabs.Help == activeTab) {
                                            return _jsx(HelpCenter, {});
                                        }
                                        return _jsx(_Fragment, {});
                                    })() })) })))] })) : (_jsx(_Fragment, {}))] })) })));
    }
    else {
        return _jsx(_Fragment, {});
    }
};
export default App;
